import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

export const topButtonsSx: SystemStyleObject<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 1.5,
  '& > *': { flexShrink: 0 },
};
